import { PopulatedLocation } from 'components/producers/new-producer-map/types'
import { RootState, store } from 'store'
import { getCapacityState } from 'utils/producers'

/**
 * Filters locations based on the hideSoldOutLocations flag
 *
 * @param {PopulatedLocation[]} locations
 * @param {boolean} hideSoldOutLocations
 * @returns {PopulatedLocation[]}
 */
export const filterLocations = (locations: PopulatedLocation[], hideSoldOutLocations: boolean): PopulatedLocation[] => {
  if (!hideSoldOutLocations || !store) return locations

  const { inputs, flows } = (store.getState() as RootState).customer

  return locations.filter((location) => {
    const capacity = getCapacityState(location, inputs.simulation, flows.simulation.didSimulation)

    return !capacity.soldOut
  })
}
